import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import CashCharge from "@/components/wallet/CashCharge";
import CashTransaction from "@/components/wallet/CashTransaction";
import useGetCashBalance from "@/components/wallet/hooks/useGetCashBalance";
import WalletLayout, { CASH_TAB_VALUE } from "@/components/wallet/Layout";
import useRedirect from "@/hooks/useRedirect";
import useSearchParams from "@/hooks/useSearchParams";
import { useAuthStore } from "@/lib/auth/AuthStore";
import { mixpanelEvent } from "@/lib/mixpanels/mixpanel";
import { CASH_INDEX_PAGE, REGISTRATION_PAGE } from "@/settings/constant";
import { Spinner, TabContent, Tabs, Typography } from "@bookips/sds";
import { useRouter } from "next/router";
import { useEffect } from "react";
import { useDialogStore } from "src/store/useDialogStore";
import useSnackbar from "src/store/useSnackbar";
export const CASH_CHARGE_TAB_VALUE = "charge";
export const CASH_HISTORY_TAB_VALUE = "history";
const tabList = [
    {
        value: CASH_CHARGE_TAB_VALUE,
        label: "캐시 충전"
    },
    {
        value: CASH_HISTORY_TAB_VALUE,
        label: "캐시 내역"
    }
];
const CashPage = ()=>{
    var _error_response;
    const router = useRouter();
    const searchParams = useSearchParams();
    const { addSnackbar  } = useSnackbar();
    var _searchParams_get;
    const activeTab = (_searchParams_get = searchParams.get("tab")) !== null && _searchParams_get !== void 0 ? _searchParams_get : CASH_CHARGE_TAB_VALUE;
    const { isLoggedIn  } = useAuthStore();
    const { data: cashBalance , isLoading , isError , error  } = useGetCashBalance();
    const is500Error = isError && (error === null || error === void 0 ? void 0 : (_error_response = error.response) === null || _error_response === void 0 ? void 0 : _error_response.status) === 500;
    const { open , close  } = useDialogStore();
    const { redirectTo , redirectToLogin  } = useRedirect();
    const showLoginRequiredDialog = ()=>{
        open({
            id: "login-required",
            type: "confirm",
            props: {
                title: "로그인이 필요해요.",
                description: "로그인 또는 회원가입을 진행해주세요.",
                confirmText: "회원가입",
                cancelText: "로그인",
                onConfirm: ()=>{
                    mixpanelEvent("Popup Button Clicked", {
                        "Popup Title": "로그인이 필요해요.",
                        "Button Name": "회원가입",
                        position: "캐시 내역"
                    });
                    redirectTo(REGISTRATION_PAGE, "".concat(CASH_INDEX_PAGE, "?tab=").concat(CASH_HISTORY_TAB_VALUE));
                },
                onCancel: ()=>{
                    mixpanelEvent("Popup Button Clicked", {
                        "Popup Title": "로그인이 필요해요.",
                        "Button Name": "로그인",
                        position: "캐시 내역"
                    });
                    redirectToLogin("".concat(CASH_INDEX_PAGE, "?tab=").concat(CASH_HISTORY_TAB_VALUE));
                },
                contentProps: {
                    onInteractOutside: ()=>{
                        close("login-required");
                    }
                }
            }
        });
    };
    useEffect(()=>{
        if (activeTab === CASH_HISTORY_TAB_VALUE && !isLoggedIn) {
            router.replace(CASH_INDEX_PAGE);
            showLoginRequiredDialog();
        }
    }, [
        activeTab,
        isLoggedIn
    ]);
    useEffect(()=>{
        if (is500Error) {
            addSnackbar({
                message: "다시 시도해주세요.",
                variant: "error"
            });
        }
    }, [
        is500Error
    ]);
    if (activeTab === CASH_HISTORY_TAB_VALUE && !isLoggedIn) {
        return null;
    }
    return /*#__PURE__*/ _jsxs(WalletLayout, {
        tabValue: CASH_TAB_VALUE,
        children: [
            isLoggedIn && /*#__PURE__*/ _jsxs("div", {
                className: "flex items-center gap-2 rounded-md border border-gray-100 bg-white px-6 py-5",
                children: [
                    /*#__PURE__*/ _jsx(Typography, {
                        variant: "h6",
                        className: "text-primary",
                        children: "보유 캐시"
                    }),
                    isLoading || is500Error ? /*#__PURE__*/ _jsx(Spinner, {
                        size: "sm",
                        className: "text-primary-main"
                    }) : /*#__PURE__*/ _jsxs(Typography, {
                        variant: "h6",
                        className: "text-primary-main",
                        children: [
                            cashBalance.totalBalance.toLocaleString(),
                            "원"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(Tabs, {
                tabs: tabList,
                value: activeTab,
                classes: {
                    list: "pt-1 bg-white border border-gray-100 border-b-0 rounded-t-md",
                    listContent: "pl-5 max-w-[598px] w-full"
                },
                onValueChange: (value)=>{
                    var _tabList_find;
                    mixpanelEvent("Tab UI Clicked", {
                        "Tab Type": "cash ".concat(value),
                        "Tab Name": (_tabList_find = tabList.find((tab)=>tab.value === value)) === null || _tabList_find === void 0 ? void 0 : _tabList_find.label
                    });
                    if (value === CASH_HISTORY_TAB_VALUE && !isLoggedIn) {
                        showLoginRequiredDialog();
                        return;
                    }
                    router.push({
                        pathname: router.pathname,
                        query: {
                            tab: value
                        }
                    });
                },
                children: [
                    /*#__PURE__*/ _jsx(TabContent, {
                        value: CASH_CHARGE_TAB_VALUE,
                        className: "flex flex-col gap-6",
                        children: /*#__PURE__*/ _jsx(CashCharge, {})
                    }),
                    /*#__PURE__*/ _jsx(TabContent, {
                        value: CASH_HISTORY_TAB_VALUE,
                        children: /*#__PURE__*/ _jsx(CashTransaction, {})
                    })
                ]
            })
        ]
    });
};
export default CashPage;
